import { render } from "./DemandNotice.vue?vue&type=template&id=6d9e32fa&scoped=true"
import script from "./DemandNotice.vue?vue&type=script&lang=js"
export * from "./DemandNotice.vue?vue&type=script&lang=js"

import "./DemandNotice.vue?vue&type=style&index=0&id=6d9e32fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9e32fa"]])

export default __exports__